import React from 'react';
import { CheckCircle2Icon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const heroImage = 'https://cdn.magicpatterns.com/uploads/eVCfzbb61tykAr2H7Kbq1n/3cdfb6fc-e757-4ff3-8362-e418522de590.webp';
const OFFER_TOP_GAP = 48;
function scrollToOffer(event: React.MouseEvent<HTMLAnchorElement>) {
  const target = document.getElementById('offer-details');
  if (!target) return;
  event.preventDefault();
  const getTop = () => target.getBoundingClientRect().top + window.scrollY - OFFER_TOP_GAP;
  window.scrollTo({
    top: getTop(),
    behavior: 'smooth'
  });

  // Images above the offer can finish loading mid-scroll and shift the layout.
  // Keep correcting the landing spot until the page settles.
  const observer = new ResizeObserver(() => {
    window.scrollTo({
      top: getTop(),
      behavior: 'auto'
    });
  });
  window.setTimeout(() => observer.observe(document.body), 700);
  window.setTimeout(() => {
    observer.disconnect();
    if (Math.abs(target.getBoundingClientRect().top - OFFER_TOP_GAP) > 4) {
      window.scrollTo({
        top: getTop(),
        behavior: 'auto'
      });
    }
  }, 2000);
}
export function HeroSection() {
  return <section className="bg-[#0A0A0A] px-5 py-6 sm:py-16" data-id="element-93" data-mp="2bfronzvbz9q9">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-94" data-mp="2p5lbkcn9zjxc">
        <div className="text-center lg:text-left" data-id="element-95" data-mp="2kdk5j8gpapfr">
          <p className="mb-3 inline-flex items-center gap-2 rounded-full border border-[#d4af37]/40 bg-[#d4af37]/10 px-3 py-1.5 text-[9px] font-bold uppercase tracking-[.14em] text-[#d4af37] sm:mb-5 sm:px-4 sm:py-2 sm:text-[11px]" data-id="element-96" data-mp="2kcs8dt7ggjnd">
            <span className="h-1.5 w-1.5 rounded-full bg-[#d4af37] sm:h-2 sm:w-2" data-id="element-97" data-mp="384ftfui1d0hq" />
            The #1 planning system for rugby coaches
          </p>
          <h1 className="font-display text-4xl font-bold uppercase leading-[.91] tracking-tight text-white sm:text-6xl md:text-7xl" data-id="element-98" data-mp="3330801by4ryt">
            Plan your entire rugby season{' '}
            <span className="text-[#d4af37]" data-id="element-99" data-mp="18sms5lo7t8z7">in under 5 minutes.</span>
          </h1>

          <div className="relative mx-auto mt-3 w-full max-w-[310px] lg:hidden" data-id="element-100" data-mp="38umo8k3dqust">
            <div className="absolute inset-4 rounded-full border border-[#d4af37]/25" aria-hidden="true" data-id="element-101" data-mp="3drmjdzyoyd55" />
            <img src={heroImage} alt="Rugby Ready 6-in-1 coaching box set" width={1336} height={1190} fetchPriority="high" className="relative z-10 mx-auto w-[78%] object-contain drop-shadow-2xl" data-id="element-102" data-mp="3itlnjc299e35" />
          </div>

          <p className="mx-auto mt-4 max-w-xl text-sm font-medium leading-relaxed text-[#B0B0C0] lg:mx-0 lg:mt-6 lg:text-base sm:text-lg" data-id="element-103" data-mp="jjewamt2bog">
            Your complete 6-in-1 rugby coaching system: 365 days of sessions,
            progressions, set pieces, kicking and physical prep.
          </p>
          <ul className="mx-auto mt-4 flex max-w-xl flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-semibold text-white lg:mx-0 lg:mt-6 lg:justify-start" data-id="element-104" data-mp="eb7u4mscpg9n">
            {['1 Main Box Set', '5 Bonuses', '365 Days of Sessions', '6 Modules', 'All Age Groups'].map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-105" data-mp="1uuj9iy3upflh">
                <CheckCircle2Icon className="h-4 w-4 text-[#d4af37]" data-id="element-106" data-mp="1pv6kq7tf5yg9" />
                {item}
              </li>)}
          </ul>
          <a href="#offer-details" onClick={scrollToOffer} className="cta-button mt-5 inline-flex w-full items-center justify-center rounded-2xl px-6 py-6 text-xl font-bold sm:text-2xl lg:mt-8 lg:w-auto" data-id="element-107" data-mp="2mkebbu8waxr1">
            GET RUGBY READY NOW
          </a>
          <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-[#B0B0C0] lg:mt-6 lg:justify-start" data-id="element-108" data-mp="28szofcbvacep">
            <span className="flex items-center gap-1.5" data-id="element-109" data-mp="31i6ju2g0ylvq">
              <LockKeyholeIcon className="h-4 w-4 text-[#d4af37]" data-id="element-110" data-mp="31gluqschbv59" />
              Secure payment
            </span>
            <span className="flex items-center gap-1.5" data-id="element-111" data-mp="2l4s2i54dcfq3">
              <ZapIcon className="h-4 w-4 text-[#d4af37]" data-id="element-112" data-mp="2q2tkemq268zz" />
              Instant access
            </span>
            <span className="flex items-center gap-1.5" data-id="element-113" data-mp="2c3apwwq66w65">
              <ShieldCheckIcon className="h-4 w-4 text-[#d4af37]" data-id="element-114" data-mp="2h12d5dfvdu40" />
              7-day guarantee
            </span>
          </div>
        </div>

        <div className="relative mx-auto hidden w-[115%] max-w-none lg:block" data-id="element-115" data-mp="34ry282sxyb7k">
          <div className="absolute inset-8 rounded-full border border-[#d4af37]/25" aria-hidden="true" data-id="element-116" data-mp="38si1bbx2rowc" />
          <img src={heroImage} alt="Rugby Ready 6-in-1 coaching box set" width={1336} height={1190} fetchPriority="high" className="relative z-10 w-full object-contain drop-shadow-2xl" data-id="element-117" data-mp="2v0le9ma9k56t" />
          <p className="relative z-10 mx-auto -mt-4 w-fit border border-[#d4af37]/30 bg-[#16161F] px-4 py-2 text-center text-xs font-bold uppercase tracking-widest text-[#d4af37]" data-id="element-118" data-mp="3shakrta5rvmj">
            Built for coaches who want structure
          </p>
        </div>
      </div>
    </section>;
}